import React from 'react';
import { Modal, Card } from '@mui/material';
import { useAutoLogout } from '../contexts/AutoLogoutContext';
import MDBox from './atoms/MDBox/MDBox';
import MDTypography from './atoms/MDTypography/MDTypography';
import MDButton from './atoms/MDButton/MDButton';
import { MUIColors } from '../models/StyleModels';
import { containerStyles } from '../helpers/helpers';

export const AutoLogoutWarning: React.FC = () => {
    const { showWarning, timeRemaining, extendSession } = useAutoLogout();

    return (
        <Modal open={showWarning} disableEscapeKeyDown>
            <MDBox {...containerStyles({ justifyContent: 'center', alignItems: 'center' })}>
                <Card {...containerStyles({
                    width: '90vw',
                    maxHeight: '30vh',
                    maxWidth: '30rem',
                    padding: '2rem',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    position: 'relative',
                })}>
                    <MDTypography
                        variant='h4'
                        fontWeight='bold'
                        color={MUIColors.SECONDARY}
                        mb={2}
                    >
                        Session Expiring
                    </MDTypography>
                    <MDTypography
                        variant='body1'
                        color={MUIColors.SECONDARY}
                        mb={3}
                    >
                        Your session will expire in {timeRemaining} seconds due to inactivity.
                    </MDTypography>
                    <MDBox {...containerStyles({
                        flexDirection: 'row',
                        height: 'fit-content',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '1rem'
                    })}>
                        <MDButton
                            onClick={extendSession}
                            variant='contained'
                            color={MUIColors.PRIMARY}
                        >
                            Stay Logged In
                        </MDButton>
                    </MDBox>
                </Card>
            </MDBox>
        </Modal>
    );
}; 